import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { fetchBots, fetchBotsSuccess, fetchBotsFailure } from '../../../actions/bots.js';
import { fetchLoginStatus, fetchLoginStatusSuccess, fetchLoginStatusFailure } from '../../../actions/login-status.js';
import { selectBot } from '../../../actions/bot-select.js';
import Dashboard from  '../../templates/DashboardBots';

//Binding the data
const mapStateToProps = (state) => {
    return {
        userBots: state.bots, // Gets the bots for the logged user
        loginStatus: state.loginStatus // Gets the current login status in the store
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchBots: () => {
            dispatch(fetchBots()).then((response) => {
                !response.error ? dispatch(fetchBotsSuccess(response.payload.data)) : dispatch(fetchBotsFailure(response.payload.data));
            });
        },
        fetchLoginStatus: () => {
            dispatch(fetchLoginStatus()).then((response) => {
                !response.error ? dispatch(fetchLoginStatusSuccess(response.payload.data)) : dispatch(fetchLoginStatusFailure(response.payload.data));
            });
        },
        selectBot: bindActionCreators(selectBot, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/redux/components/pages/DashboardBots/DashboardBotsContainer.js